module.exports = __webpack_public_path__ + "static/media/Ellipse-1.45098cdd.svg";